import {Component, Input, inject} from '@angular/core';
import {RgEvent} from '../../realguest/classes/rg-event';
import {EventStatus} from '../../events/classes/event-status';
import {AsyncPipe} from '@angular/common';
import {MatIcon} from '@angular/material/icon';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Component({
    selector: 'nbd-event-status-badge',
    templateUrl: './event-status-badge.component.html',
    imports: [
        MatIcon,
        TranslateModule,
        AsyncPipe
    ],
    styleUrls: ['./event-status-badge.component.scss']
})
export class EventStatusBadgeComponent {
  private ts = inject(TranslateService);


  eventStatusBadges: StatusBadgeConfig[] = [];

  eventStatusCfg: { [key in EventStatus]?: StatusBadgeConfig } = {
    [EventStatus.Enabled]: {
      label: "toolbar.event-status-badge.enabled",
      icon: "task_alt",
      bgClass: "mat-bg-success",
    },
    [EventStatus.NotEnabled]: {
      label: "toolbar.event-status-badge.notEnabled",
      icon: "warning",
      bgClass: "mat-bg-warning",
    },
    [EventStatus.Running]: {
      label: "toolbar.event-status-badge.running",
      icon: "calendar_today",
      bgClass: "mat-bg-accent",
      class: "mat-text-accent-contrast",
    },
    [EventStatus.Finished]: {
      label: "toolbar.event-status-badge.finished",
      icon: "event_busy",
      bgClass: "mat-bg-warn",
    },
    [EventStatus.StartingSoon]: {
      label: "toolbar.event-status-badge.startingSoon",
      icon: "schedule",
      bgClass: "starting-soon"
    },
    // Sub-hour countdown: `amount` is 0 and there is no unit worth printing, so
    // this one gets its own uninterpolated label.
    [EventStatus.StartingVerySoon]: {
      label: "toolbar.event-status-badge.startingVerySoon",
      icon: "schedule",
      bgClass: "starting-soon"
    }
  };

  @Input() set event(event: RgEvent | null) {
    this.setEventBadges(event);
  }

  private setEventBadges(event: RgEvent | null) {
    this.eventStatusBadges = [];

    if (!event) {
      return;
    }

    // if (event.enabled) {
    //   this.eventStatusBadges.push(this.eventStatusCfg[EventStatus.Enabled]);
    // }

    if (event.running && !event.enabled) {
      this.eventStatusBadges.push(this.eventStatusCfg[EventStatus.NotEnabled]!);
    }


    // A sub-hour countdown carries `{amount: 0, unit: 'soon'}` — no number to
    // print, so it uses the standalone label instead of the interpolated one.
    if (event.timeToEvent?.unit === 'soon') {
      this.eventStatusBadges.push(this.eventStatusCfg[EventStatus.StartingVerySoon]!);
      return;
    }

    // `unit` is empty for an event that has already started or is over (see
    // EventsService.setEventViewData) — gating on `amount >= 0` alone let those
    // through, rendering the raw `common.system.` key and hiding the
    // Running / Finished badges below.
    if (event.timeToEvent?.unit && event.timeToEvent.amount >= 0) {
      this.eventStatusBadges.push({
        ...this.eventStatusCfg[EventStatus.StartingSoon]!,
        // label: this.ts.instant(this.eventStatusCfg[EventStatus.StartingSoon].label, {
        //   amount: Math.floor(event.timeToEvent.amount).toString(),
        //   unit: this.ts.instant(`common.system.${event.timeToEvent.unit}`)
        // })
        labelParams: this.ts.stream(`common.system.${event!.timeToEvent!.unit}`).pipe(
          map((unit) => ({
            amount: Math.floor(event!.timeToEvent!.amount).toString(),
            unit
          }))
        )
        // label: this.eventStatusCfg[EventStatus.StartingSoon].label
        //   .replaceAll("{{amount}}", Math.floor(event.timeToEvent.amount).toString())
        //   .replaceAll("{{unit}}", this.ts.instant(`common.system.${event.timeToEvent.unit}`))
      });
      return;
    }

    if (event.running) {
      this.eventStatusBadges.push(this.eventStatusCfg[EventStatus.Running]!);
      return;
    }

    if (event.finished) {
      this.eventStatusBadges.push(this.eventStatusCfg[EventStatus.Finished]!);
      return;
    }
  }

}

export interface StatusBadgeConfig {
  label: string;
  labelParams?: Observable<{ [key: string]: string }>;
  icon?: string;
  class?: string;
  bgClass?: string;
}
